import * as React from 'react';
import { useEffect, useState } from 'react';
import { api, CreateCaseDraftData } from './create/api';
import { api as apiEdit } from './edit/api';
import { AppSetting } from 'dependencies/appsettings';
import { toStartupView } from 'app/area/shared/navigation';

export const withRecaptchaApi = (WrappedComponentFactory: (api?: any) => React.ComponentType<React.PropsWithChildren<unknown>>) => {
  if (!AppSetting.GoogleRecaptchaSiteKey) {
    return WrappedComponentFactory();
  }

  let captchaToken: string = undefined;

  const captchaApi = {
    createCase: async (
      bodyParameters: CreateCaseDraftData,
      queryParameters?: { [key: string]: string | number }
    ): Promise<number> => {
      return api.createCase(bodyParameters, queryParameters, captchaToken);
    },
    editCase: async (
      caseId: number,
      caseContextId: number = undefined
    ): Promise<{ location: number; response: any }> => apiEdit.editCase(caseId, caseContextId, captchaToken)
  };

  const Container = WrappedComponentFactory(captchaApi);

  const RecaptchaHandler: React.FC<any> = (props) => {
    const SITE_KEY = AppSetting.GoogleRecaptchaSiteKey;
    const [ready, setReady] = useState(false);
    let timeout: any;
    let observer: MutationObserver;
    const [token, setToken] = useState<string>();

    useEffect(() => {
      if ((window as any).grecaptcha) {
        (window as any).grecaptcha.enterprise.ready(() => {
          (window as any).grecaptcha.enterprise
            .execute(SITE_KEY, { action: 'anonymous_case' })
            .then((result: string) => {
              setToken(result);
            })
            .catch(_ => {
              handleError();
            });
        });
      }

      return () => {
        if (timeout) {
          clearTimeout(timeout);
        }
        if (observer) {
          observer.disconnect();
        }
      };
    }, []);

    useEffect(() => {
      if (token) {
        handleSubmit();
      }
    }, [token]);

    const handleSubmit = () => {
      captchaToken = token;
      setReady(true);
    };

    const handleError = () => {
      toStartupView();
    };

    return (
      <>
        {ready && <Container {...props} />}
      </>
    );
  };

  return RecaptchaHandler;
};
